export enum ControlObjectType {
	ActivityPlace = 1,
	ControlPoint = 2,
}
